<div
  class="virtual-grid-container virtual-grid--stripped text-16"
  [class.virtual-grid--small]="rowHeight === 'small'"
  [class.virtual-grid--big]="rowHeight === 'large'"
  [class.virtual-grid--rtl]="rtl"
  [class.virtual-grid--stripped]="enableZebraStyle"
  [class.virtual-grid--divider]="enableRowDivider"
>
  <div
  class="flex flex--left flex-row flex--nowrap"
  class="virtual-grid-filter" wfmScrollbar
  >

    <!-- Filter Tag Panel -->
    <ng-container *ngIf="!hideHeader">
      <virtual-grid-filter-tag-panel
        [filterCriteria]="filterCriteria"
        (filterCriteriaChange)="filterCriteriaChange.emit($event); detectChanges()"
      >
      </virtual-grid-filter-tag-panel>
    </ng-container>

    <!-- grid top actions element-->
    <div
        id="virtualGridTopActions" class='flex flex--row flex--nowrap flex--right vg-top-actions'
        *ngIf="topActionsTemplate"
        [wfmDomTemplate]="topActionsTemplate | generateTemplate"
    ></div>
  </div>

  <!-- Header -->
  <ng-container *ngIf="!hideHeader && layout && layout.length">
    <virtual-grid-header
      class="virtual-grid-header-component"
      [class.no-bottom-border]="!gridNotification"
      [gridWidth]="gridWidth"
      [hidden]="hideHeader"
      [layout]="layout"
      [rtl]="rtl"
      [frozenColumn]="frozenColumn"
      [frozenColumns]="frozenColumns"
      [unfrozenColumns]="unfrozenColumns"
      [frozenSize]="frozenSize"
      [checkboxSelection]="checkboxSelection"
      [filterCriteria]="filterCriteria"
      [sortCriteria]="sortCriteria"
      [(horizontalScrollPosition)]="horizontalScrollPosition"
      [(selectAll)]="selectAll"
      (selectAllChange)="selectAllChange($event)"
      [disableHeaderContextMenu]="disableHeaderContextMenu"
      [accessibleInstitutes]="accessibleInstitutes"
      [instituteSeparationEnabled]="instituteSeparationEnabled"
      (contextMenuOperationSelected)="selectHeaderContextMenuOperation($event)"
      (columnReordered)="reorderedColumn($event)"
      (columnResized)="columnResized.emit($event); onColumnResized()"
      (columnResizeEnd)="columnResizeEnd.emit($event)"
      (filterCriteriaChange)="filterCriteriaChange.emit($event); detectChanges()"
      (sortCriteriaChange)="sortCriteriaChange.emit($event); detectChanges()"
      (frozenColumnChange)="changeFrozenColumn($event)"
      (horizontalScrollPositionChange)="horizontalScrollPositionChange()"
    ></virtual-grid-header>
  </ng-container>

  <div
    *ngIf="gridNotification && !(!items || items.length)"
    class="flex flex--nowrap flex--col flex--middle flex--left u-p--- notification text-align--center"
  >
    <div
      id="gridNotification.primaryText"
      class="text-bold-16"
      [innerHTML]="gridNotification.primaryText | translate"
    ></div>
    <div
      id="gridNotification.secondaryText"
      class="text-bold-12 u-mt---"
      [innerHTML]="gridNotification.secondaryText | translate"
    ></div>
    <button
      *ngIf="gridNotification.notificationAction"
      type="button"
      (click)="notificationActionClicked(); $event.stopPropagation()"
      aria-pressed="false"
      class="button u-mt-"
      style="height: 3rem"
    >
      <span
        id="gridNotification.notificationAction.label"
        [innerHTML]="gridNotification.notificationAction.label | translate"
      ></span>
    </button>
  </div>

  <div class="virtual-grid-scroll-container" [class.notification]="gridNotification && !(!items || items.length)">
    <!-- CDK virtual scroll implements and manage the scroll, keeping in the DOM only the visible elements -->
    <cdk-virtual-scroll-viewport
      id="cdk-virtual-scroll-viewport"
      class="virtual-grid-body no-scroll-scrollable"
      [itemsProfiles]="itemsProfiles"
      (scroll)="scrollHandler($event)"
      (wheel)="onWheel($event)"
      (error)="errorNotify.emit($event)"
    >
      <!-- To Show Spinner while loading -->
      <div
        *ngIf="loading && !items.length"
        class="flex flex--row flex--nowrap flex--center flex--middle u-mt--- spinner"
      >
        <wfm-spinner [size]="40"></wfm-spinner>
      </div>

      <!-- work items / work rows -->
      <!-- By using ng-container, we can use templates and customize the content -->
      <!-- WFM will use custom template to display the card layout -->
      <div
        id="work-items"
        (mouseleave)="onMouseLeave()"
      >
          <ng-container *cdkVirtualFor="let item of displayedItems; index as rowIndex; odd as odd">
            <div
              class="virtual-grid-row "
              [ngClass]="item.customClass ? 'virtual-grid-row-custom-'+item.customClass : ''"
              id="work-item-{{ rowIndex }}"
              #row
              *ngIf="!(item | isVirtualGridGroup)"
              (click)="click($event, item, rowIndex)"
              (mousedown)="$event.preventDefault()"
              (mouseenter)="onGridRowMouseEnter(rowIndex)"
              (contextmenu)="openContextMenu($event, item, rowIndex)"
              [style.max-height.px]="rowHeightPX"
              [style.min-height.px]="rowHeightPX"
              [class.odd]="odd"
              [class.vg-selected]="selectedItemsMap[rowIndex] && !selectedOverlay"
              [class.vg-selected-overlay]="selectedItemsMap[rowIndex] && selectedOverlay"
              [class.vg-activated]="activatedItemsMap[rowIndex]"
              [class.no-top-border]="
                !!activatedItemsMap[rowIndex - 1] === !!activatedItemsMap[rowIndex] &&
                !!selectedItemsMap[rowIndex - 1] === !!selectedItemsMap[rowIndex]
              "
              [class.no-bottom-border]="
                !!activatedItemsMap[rowIndex + 1] === !!activatedItemsMap[rowIndex] &&
                !!selectedItemsMap[rowIndex + 1] === !!selectedItemsMap[rowIndex]
              "
              [class.no-top-border-hover]="
                !selectedItemsMap[rowIndex] && !!selectedItemsMap[rowIndex - 1] && !selectedOverlay
              "
              [class.no-bottom-border-hover]="
                !selectedItemsMap[rowIndex] && !!selectedItemsMap[rowIndex + 1] && !selectedOverlay
              "
            >
              <ng-container
                *ngIf="item.rowTemplate || rowTemplate || workListRow | isTemplateRef"
                [ngTemplateOutlet]="item.rowTemplate || rowTemplate || workListRow"
                [ngTemplateOutletContext]="{ layout: layout, rIndex: rowIndex, item: item }"
              >
              </ng-container>
              <div
                class="virtual-grid-template-wrap"
                *ngIf="!(item.rowTemplate || rowTemplate || workListRow | isTemplateRef)"
                [wfmDomTemplate]="
                  item.rowTemplate || rowTemplate | generateTemplate: { layout: layout, rIndex: rowIndex, item: item }
                "
              ></div>
              <div class="virtual-grid-row-overlay"></div>
            </div>

            <div
              class="virtual-grid-row virtual-grid-group flex"
              *ngIf="item | isVirtualGridGroup"
              [style.left.px]="0"
              [style.height.px]="groupHeaderHeight"
              [style.max-height.px]="groupHeaderHeight"
              [class.odd]="odd"
              [attr.id]="item.id"
              (click)="toggleGroupCollapsed(item)"
              (mouseenter)="onGroupMouseEnter()"
            >
              <ng-container
                *ngIf="item.groupHeaderTemplate || groupHeaderTemplate || groupHeader | isTemplateRef"
                [ngTemplateOutlet]="item.groupHeaderTemplate || groupHeaderTemplate || groupHeader"
                [ngTemplateOutletContext]="{ group: item, rIndex: rowIndex }"
              >
              </ng-container>
              <div
                class="virtual-grid-cell"
                *ngIf="!(item.groupHeaderTemplate || groupHeaderTemplate || groupHeader | isTemplateRef)"
                [wfmDomTemplate]="
                  item.groupHeaderTemplate || groupHeaderTemplate
                    | generateTemplate: { group: item, rIndex: rowIndex }:groupStringTemplate
                "
              ></div>
            </div>
          </ng-container>
      </div>
    </cdk-virtual-scroll-viewport>

    <wfm-scrollbar
      *ngIf="verticalScrollSize > verticalOffsetSize && verticalOffsetSize"
      orientation="vertical"
      [offsetSize]="verticalOffsetSize"
      [scrollSize]="verticalScrollSize"
      [arrowIncrement]="rowHeightPX"
      [position]="verticalScrollPosition"
      (positionChangeEnded)="verticalScrollPositionChange($event)"
    >
    </wfm-scrollbar>
  </div>

  <!-- To Show Spinner while loading -->
  <div
    *ngIf="enableNextPageLoadingSpinner && nextPageSpinner"
    class="flex flex--row flex--nowrap flex--center flex--bottom vg-loading-spinner"
  >
    <wfm-spinner [size]="20"></wfm-spinner>
  </div>
  <!-- Footer -->
  <div class="virtual-grid-footer" #workListFooter>
    <ng-content></ng-content>
  </div>

  <wfm-scrollbar
    *ngIf="horizontalScrollSize > horizontalOffsetSize && horizontalOffsetSize"
    orientation="horizontal"
    [style.max-width.px]="gridWidth"
    [offsetSize]="horizontalOffsetSize"
    [scrollSize]="horizontalScrollSize"
    [reverse]="rtl"
    [(position)]="horizontalScrollPosition"
    (positionChange)="horizontalScrollPositionChange()"
  >
  </wfm-scrollbar>
</div>

<!-- Default template for the row -->
<ng-template #workListRow let-layout="layout" let-item="item" let-rIndex="rIndex">
  <!--
    this div contains the frozen columns.
    It remains static in the left hand side of the grid
  -->
  <div class="virtual-grid-frozen-columns" [style.width.px]="frozenSize" [style.min-width.px]="frozenSize">
    <div class="checkbox-select virtual-grid-cell virtual-grid-cell-first" *ngIf="checkboxSelection">
      <label class="checkbox" (click)="$event.stopPropagation()">
        <input
          type="checkbox"
          class="checkbox__input"
          [checked]="selectedItemsMap[rIndex]"
          (click)="selectItem($event, item, rIndex, true); $event.stopPropagation()"
        />
        <span class="checkbox__label"> </span>
      </label>
    </div>

    <ng-container
      [ngTemplateOutlet]="cellListTemplate"
      [ngTemplateOutletContext]="{ columns: frozenColumns, layout: layout, item: item, rIndex: rIndex }"
    >
    </ng-container>
  </div>

  <!--
    this div contains the unfrozen columns.
    when a horizontal scroll is present, only this columns will scroll.
    the scroll will happen under the frozen columns.
  -->
  <div
    class="virtual-grid-unfrozen-columns no-scroll-scrollable"
    #unfrozenRow
    [scrollLeft]="horizontalScrollPosition * rtlSignal"
    [attr.scroll-left]="horizontalScrollPosition * rtlSignal"
    (scroll)="unfrozenScrollHandler($event)"
  >
    <!-- <div class="flex flex--row flex--nowrap" [style.min-width.px]="horizontalScrollSize"> -->
    <!-- cells -->
    <!-- By using ng-container, we can use templates and customize the content -->
    <ng-container
      [ngTemplateOutlet]="cellListTemplate"
      [ngTemplateOutletContext]="{ columns: unfrozenColumns, layout: layout, item: item, rIndex: rIndex }"
    >
    </ng-container>
    <!-- </div> -->
  </div>

  <ng-container
    *ngIf="rowActionsTemplate && currentHoverItemIndex === rIndex">
      <ng-container
        *ngIf="(rowActionsTemplate | generateTemplate) as domTemplate">
          <div
              id="Actions_Element_{{rIndex}}"
              class="flex flex--row flex--nowrap flex--right u-pr-- vg-row-actions"
              [wfmDomTemplate]="domTemplate"
              [class.vg-selected]="selectedItemsMap[rIndex]"
              [style.max-height.px]="rowHeightPX"
              [style.min-height.px]="rowHeightPX"
              [style.right.px]="rowActionsElementRightPX"
              [class.no-top-border-hover]="!selectedItemsMap[rIndex] && !!selectedItemsMap[rIndex - 1] && !selectedOverlay"
              [class.no-bottom-border-hover]="!selectedItemsMap[rIndex] && !!selectedItemsMap[rIndex + 1] && !selectedOverlay"
          ></div>
      </ng-container>
  </ng-container>

</ng-template>

<ng-template #cellListTemplate let-columns="columns" let-layout="layout" let-item="item" let-rIndex="rIndex">
  <ng-container *ngFor="let column of columns; index as i; first as first; last as last">
    <div
      class="virtual-grid-cell {{ 'virtual-grid-cell-' + column.propertyName }}"
      *ngIf="!column.isHidden"
      [ngClass]="column.cellStyleClasses"
      [style.width.px]="column.width"
      [style.min-width.px]="column.width || column.minWidth"
      [style.max-width.px]="column.maxWidth"
      [class.virtual-grid-cell-first]="!checkboxSelection && column === firstVisibleColumn"
      [class.virtual-grid-cell-last]="column === lastVisibleColumn"
      [class.sized]="column.width != undefined"
      [class.size-2]="column.responsiveSize === 2"
      [class.size-3]="column.responsiveSize === 3"
    >
      <ng-container
        *ngIf="column.cellTemplate || cellTemplate || workListCell | isTemplateRef"
        [ngTemplateOutlet]="column.cellTemplate || cellTemplate || workListCell"
        [ngTemplateOutletContext]="{
          column: column,
          item: item,
          id: item[rowIdentifier] + '-' + column.propertyName,
          data: (item | getPropertyValue: column.propertyName:column),
          cIndex: i,
          rIndex: rIndex
        }"
      >
      </ng-container>
      <div
        *ngIf="!(column.cellTemplate || cellTemplate || workListCell | isTemplateRef)"
        [wfmDomTemplate]="
          column.cellTemplate || cellTemplate
            | generateTemplate
              : {
                  column: column,
                  item: item,
                  id: item[rowIdentifier] + '-' + column.propertyName,
                  data: (item | getPropertyValue: column.propertyName:column),
                  cIndex: i,
                  rIndex: rIndex
                }
              : cellStringTemplate
        "
      ></div>
    </div>
  </ng-container>
</ng-template>

<!-- Default template for the cell -->
<ng-template #workListCell let-data="data" let-item="item" let-column="column" let-id="id">
  <div
    id="{{ id }}"
    class="text-ellipsis virtual-grid-cell-content"
    [tooltip]="data"
    [overflowOnly]="true"
    [delay]="1000"
  >
    {{ data }}
  </div>
</ng-template>

<!-- START grid context menu items -->
<ng-template #gridContextMenu let-item="item" let-index="index">
  <ul
    role="menu"
    class="menu__panel menu__panel--right virtual-grid-context-menu"
    aria-hidden="false"
    wfmScrollbar
    *ngIf="contextMenuOperations && contextMenuOperations.length"
  >
    <ng-container *ngFor="let menuOperation of contextMenuOperations">
      <li class="menu__item-wrap" *ngIf="!menuOperation.isHidden">
        <div class="menu__item-divider" *ngIf="menuOperation.enableDivider"></div>
        <button
          type="button"
          class="menu__item text-16"
          (click)="contextMenuSelected(menuOperation); $event.stopPropagation()"
          id="{{ 'vg-context-menu-action-' + menuOperation.id }}"
        >
          <span id="{{ 'vg-context-menu-' + menuOperation.id }}" class="menu__item-text">{{
            menuOperation.label | translate
          }}</span>
          <span
            *ngIf="menuOperation.subMenu && menuOperation.subMenu.length"
            aria-hidden="true"
            class="menu__icon menu__icon--more menu__icon--arrow-right"
          >
            <svg
              data-name="caret right - 12"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <path
                d="M3,12a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L7.79,6,2.65.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l5.5,5.5a.48.48,0,0,1,0,.7l-5.5,5.5A.47.47,0,0,1,3,12Z"
              ></path>
            </svg>
          </span>
        </button>
        <ul
          *ngIf="menuOperation.subMenu && menuOperation.subMenu.length"
          class="menu__panel menu__panel--children virtual-grid-context-menu"
        >
          <ng-container *ngFor="let subMenuOperation of menuOperation.subMenu">
            <li class="menu__item-wrap" *ngIf="!subMenuOperation.isHidden">
              <div class="menu__item-divider" *ngIf="subMenuOperation.enableDivider"></div>
              <button
                type="button"
                class="menu__item text-16 menu__item--child"
                (click)="contextMenuSelected(subMenuOperation); $event.stopPropagation()"
                id="{{ 'vg-sub-menu-action-' + subMenuOperation.id }}"
              >
                <span id="{{ 'vg-sub-menu-' + subMenuOperation.id }}" class="menu__item-text">{{
                  subMenuOperation.label | translate
                }}</span>
              </button>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</ng-template>
<!-- END grid context menu items -->

<!--START Group Header Template -->
<ng-template #groupHeader let-group="group" let-rIndex="rIndex">
  <div class="checkbox-select virtual-grid-cell virtual-grid-cell-first" *ngIf="checkboxSelection">
    <label class="checkbox">
      <input type="checkbox" class="checkbox__input" [checked]="group.selected" (click)="selectgroup($event, group)" />
      <span class="checkbox__label"> </span>
    </label>
  </div>
  <div
    class="virtual-grid-cell no-scroll no-wrap children--div--inline-block"
    [ngClass]="gridWidth <= 500 ? ['flex', 'flex--row', 'flex--nowrap'] : ''"
    [tooltip]="groupHeaderTooltip"
    [tooltipData]="group"
    [overflowOnly]="gridWidth > 500"
    [tooltipMaxWidth]="gridWidth + 'px'"
    ellipsis
  >
    <div>
      <span class="group-identation" [style.margin-left.px]="30 * group.level"></span>
      <span class="group-icon u-mr--">
        <svg-icon
          name="ico-caret-up-16"
          *ngIf="!group.collapsed"
          [ngStyle]="{ height: '16px' }"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
        >
        </svg-icon>
        <svg-icon
          name="ico-caret-down-16"
          *ngIf="group.collapsed"
          [ngStyle]="{ height: '16px' }"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
        >
        </svg-icon>
      </span>
    </div>

    <ng-container
      [ngTemplateOutlet]="
        group.labels && group.labels.length && gridWidth > 500 ? groupHeaderMultiLabels : groupHeaderSingleLabel
      "
      [ngTemplateOutletContext]="{
        data: group.labels && group.labels.length && gridWidth <= 500 ? group.labels[0] : group,
        template: groupHeaderSingleLabel
      }"
    >
    </ng-container>

    <div *ngIf="gridWidth <= 500 && group.labels && group.labels.length > 1" class="group-cell-more">&hellip;</div>
  </div>
</ng-template>
<!--END Group Header Template -->

<ng-template #groupHeaderMultiLabels let-group="data" let-template="template">
  <ng-container
    *ngFor="let label of group.labels"
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{ data: label }"
  ></ng-container>
</ng-template>

<ng-template #groupHeaderSingleLabel let-group="data">
  <div class="group-label-pair flex flex--nowrap flex--middle text-ellipsis u-pr">
    <span class="group-label text-ellipsis u-mr--" *ngIf="group.label">{{ group.label | translate }}</span>
    <span class="group-data flex--item--zero text-ellipsis text-bold-16">{{ group.data }}</span>
  </div>
</ng-template>

<ng-template #groupHeaderSingleLabelTooltip let-group="data">
  <div>
    <span class="group-label u-mr--" *ngIf="group.label">{{ group.label | translate }}</span>
    <span class="group-data text-bold-16">{{ group.data }}</span>
  </div>
</ng-template>

<ng-template #groupHeaderTooltip let-group="data">
  <div>
    <ng-container
      [ngTemplateOutlet]="group.labels && group.labels.length ? groupHeaderMultiLabels : groupHeaderSingleLabel"
      [ngTemplateOutletContext]="{
        data: group,
        template: groupHeaderSingleLabelTooltip
      }"
    >
    </ng-container>
  </div>
</ng-template>
